import Collapse from "./Collapse";
export default Collapse;

/**
 * @deprecated use `items` instead, will be removed in `v4.0.0`
 */
var Panel = Collapse.Panel;
export { Panel };